const GQL_CURRICULUM_LESSON_PLANS_DATA = `
query GetCurriculumLessonPlans($districtId: String!, $grade: Grade!, $schoolYear: Int!, $filter: CurriculumLessonPlansFilter = {}) {
  getCurriculumLessonPlans(
    districtId: $districtId
    grade: $grade
    schoolYear: $schoolYear
    filter: $filter
  ) {
    id
    curriculumId
    description
    entityId
    displayName
    entityType
    grade
    iconUrl
    isFinalized
    lessonPlanName
    locale
    localeId
    schoolYear
    sequence
    tracks {
      id
      sequence
      displayName
      units {
        id
        displayName
        curriculumTrackId
        sequence
        status
        lessons {
          id
          displayName
          duration
          durationType
          dateFrom
          dateTo
          sequence
          status
          skills {
            id
            skillId
            skillName
            skillType
            sequence
            displayName
            windowPeriod
          }
        }
      }
    }
  }
}`;

const GQL_GET_CURRICULUM_LESSON_PLANS_AVAILABLE = `
query GetCurriculumLessonPlansAvailable($districtId: String = null, $curriculumIds: [String!] = null, $grades: [Grade!] = null, $locales: [Locale!] = null, $schoolYear: Int = null) {
  getCurriculumLessonPlansAvailable(
    districtId: $districtId
    curriculumIds: $curriculumIds
    grades: $grades
    locales: $locales
    schoolYear: $schoolYear
  ) {
    curriculumId
    curriculumName
    curriculumDescription
    curriculumIconUrl
    curriculumLessonPlanId
    grade
    locale
    schoolYear
  }
}`;

const GQL_SAVE_CURRICULUM_LESSON_PLAN = `
mutation SaveCurriculumLessonPlan($districtId: String = "", $grade: Grade = PK, $savedBy: String = "", $schoolYear: Int = 10, $plans: [CurriculumLessonPlanInput!] = {curriculumId: ""}, $overrideGradeData: Boolean = false) {
  savePlans(
    districtId: $districtId
    grade: $grade
    savedBy: $savedBy
    schoolYear: $schoolYear
    plans: $plans
    overrideGradeData: $overrideGradeData
  ) {
    data {
      data {
        id
        displayName
        entityId
        entityType
        lessonPlanName
        curriculumId
        description
      }
      messages
      exceptions {
        exceptionDesc
        exceptionMessage
      }
    }
    isSuccess
    statusCode
    successCount
    errorCount
  }
}`;

const GQL_CLONE_CURRICULUM_LESSON_PLANS = `
mutation CloneCurriculumLessonPlans($clonedBy: String!, $districtId: String!, $schoolYear: Int!, $planIds: [String!]!, $overridePlanData: Boolean) {
  clonePlans(
    clonedBy: $clonedBy
    districtId: $districtId
    schoolYear: $schoolYear
    planIds: $planIds
    overridePlanData: $overridePlanData
  ) {
    data {
      data
      isSuccess
      statusCode
      messages
      exceptions {
        exceptionDesc
        exceptionMessage
      }
    }
    isSuccess
    statusCode
    itemCount
    successCount
    errorCount
  }
}`;

export {
  GQL_CLONE_CURRICULUM_LESSON_PLANS,
  GQL_CURRICULUM_LESSON_PLANS_DATA,
  GQL_GET_CURRICULUM_LESSON_PLANS_AVAILABLE,
  GQL_SAVE_CURRICULUM_LESSON_PLAN
};
